import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom'; // Caso use React Router

export default function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <Result
        status="403"
        title="403"
        subTitle="Desculpe, você não tem autorização para acessar esta página."
        extra={
          <div style={styles.buttonGroup}>
            <Button type="default" onClick={() => navigate(-1)}>
              Voltar
            </Button>

            <Button type="primary" onClick={() => navigate('/')}>
              Ir para o Início
            </Button>
          </div>
        }
      />
    </div>
  );
}

// Estilização simples para centralizar na tela
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f0f2f5', // Cor de fundo padrão do Antd
    padding: '20px',
  },
  buttonGroup: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
  },
};
